import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class Items {
  constructor () {
    const base = axios.create({
      // using base items api
      baseURL: process.env.VUE_APP_ITEMS_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.items = base
  }

  async getSourceRelsByPartyId (partyId) {
    await AuthToken.setAuth(this.items, {
      audience: process.env.VUE_APP_ITEM_AUDIENCE
    })
    return this.items({
      url: `/source/relationships/party/${partyId}`,
      method: 'GET'
    })
  }

  async getSourceRelationships () {
    await AuthToken.setAuth(this.items, {
      audience: process.env.VUE_APP_ITEM_AUDIENCE
    })
    return this.items({
      url: `/sources/relationships`,
      method: 'GET'
    })
  }

  async getSources () {
    await AuthToken.setAuth(this.items, {
      audience: process.env.VUE_APP_ITEM_AUDIENCE
    })
    return this.items({
      url: `/sources`,
      method: 'GET'
    })
  }

  async* searchItems(payload, offset = 0, limit = 300) {
    await AuthToken.setAuth(this.items, {
      audience: process.env.VUE_APP_ITEM_AUDIENCE
    })

    let page = 1
      
     while (true) {
      offset = (page * limit) - limit
  
      const res = await this.items({
        url: `/item_search/`,
        method: 'POST',
        data: payload,
        params: { offset, limit }
      })

      if (!res.data || res.data.length === 0) {
        break
      }
    
      yield res.data
    
      if (res.data.length < limit) break
      page++
    }
  }
}

export default new Items()